export default "daa74c77b31cabc4.svg"